import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence, useReducedMotion } from 'framer-motion';
import { Link } from 'react-router-dom';
import { UtensilsCrossed, HardHat, ShoppingBag, Scissors, Dumbbell, Sparkles } from 'lucide-react';
import './IndustriesSection.css';

const EASE = [0.22, 0.61, 0.36, 1];

const ROTATE = ['restaurants', 'contractors', 'online stores', 'salons', 'auto shops', 'gyms'];

const INDUSTRIES = [
  { icon: UtensilsCrossed, label: 'Restaurants', to: '/industries/restaurants' },
  { icon: HardHat, label: 'Contractors', to: '/industries/contractors' },
  { icon: ShoppingBag, label: 'Online stores', to: '/industries/online-stores' },
  { icon: Scissors, label: 'Salons & spas', to: '/industries/salons-spas' },
  { icon: Dumbbell, label: 'Gyms & studios', to: '/industries/gyms-studios' },
  { icon: Sparkles, label: '& more', to: '/industries' }
];

function IndustriesSection() {
  const reduce = useReducedMotion();
  const [i, setI] = useState(0);

  useEffect(() => {
    if (reduce) return undefined;
    const t = setInterval(() => setI((p) => (p + 1) % ROTATE.length), 2100);
    return () => clearInterval(t);
  }, [reduce]);

  const rise = (d) =>
    reduce
      ? {}
      : {
          initial: { opacity: 0, y: 24 },
          whileInView: { opacity: 1, y: 0 },
          viewport: { once: true, amount: 0.3 },
          transition: { duration: 0.6, delay: d, ease: EASE }
        };

  return (
    <section className="vind" aria-label="Versa Launch works for every kind of local business">
      <div className="vind-inner">
        <motion.span className="vind-eyebrow" {...rise(0)}>One platform for every local business</motion.span>

        <motion.h2 className="vind-title" {...rise(0.06)}>
          Built to grow
          <span className="vind-rotator" aria-hidden="true">
            <AnimatePresence initial={false} mode="popLayout">
              <motion.span
                key={ROTATE[i]}
                className="vind-word"
                initial={reduce ? false : { y: '0.95em', opacity: 0 }}
                animate={{ y: 0, opacity: 1 }}
                exit={reduce ? { opacity: 0 } : { y: '-0.95em', opacity: 0 }}
                transition={{ duration: 0.42, ease: EASE }}
              >
                {ROTATE[i]}
              </motion.span>
            </AnimatePresence>
          </span>
          <span className="sr-only"> restaurants, contractors, online stores, and more</span>
        </motion.h2>

        <motion.p className="vind-sub" {...rise(0.12)}>
          Restaurants, contractors, online stores, and more. One platform that flexes to fit any
          business. That&rsquo;s what makes us <span className="vind-versa">Versa</span><span className="vind-tile">tile</span>.
        </motion.p>

        <motion.ul className="vind-grid" {...rise(0.18)}>
          {INDUSTRIES.map(({ icon: Icon, label, to }) => (
            <li key={label}>
              <Link to={to} className="vind-card">
                <span className="vind-card-ic"><Icon size={22} strokeWidth={2} /></span>
                <span className="vind-card-label">{label}</span>
              </Link>
            </li>
          ))}
        </motion.ul>
      </div>
    </section>
  );
}

export default IndustriesSection;
